"use client";

import { EmblaOptionsType } from "embla-carousel";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import Image from "next/image";
import "./carousel.css";

interface PropType {
  slides: {
    src: string;
  }[];
}

const AUTOPLAY_OPTIONS = {
  delay: 5000,
  stopOnInteraction: false,
};

const OPTIONS: EmblaOptionsType = { loop: true };

const TeamCarousel = (props: PropType) => {
  const { slides } = props;
  const [emblaRef] = useEmblaCarousel(OPTIONS, [Autoplay(AUTOPLAY_OPTIONS)]);

  return (
    <section className="emblas px-4 py-8">
      <div className="embla__viewports" ref={emblaRef}>
        <div className="embla__containers">
          {slides.map((slide, index) => (
            <div className="embla__slides" key={index}>
              <Image
                className="embla__slide__numbers"
                src={slide.src}
                alt={`Team der Grundriss Schmiede`}
                width={720}
                height={480}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamCarousel;
